/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_4_TitleInputs */

const en_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda Ripple`)
};

const ar_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صودا ريبل`)
};

const de_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda-Welle`)
};

const es_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burbujeo de soda`)
};

const fr_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondulation Soda`)
};

const it_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blu Frizzante`)
};

const ja_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソーダウェーブ`)
};

const ko_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`청량한 파도`)
};

const pt_br_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onda tônica`)
};

const ru_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содовая рябь`)
};

const th_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกลียวคลื่นโซดา`)
};

const tr_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soda Dalgası`)
};

const zh_cn_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`苏打涟漪`)
};

const zh_tw_land_skin_4_title = /** @type {(inputs: Land_Skin_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蘇打漣漪`)
};

/**
* | output |
* | --- |
* | "Soda Ripple" |
*
* @param {Land_Skin_4_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_4_title = /** @type {((inputs?: Land_Skin_4_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_4_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_4_title(inputs)
	if (locale === "ar") return ar_land_skin_4_title(inputs)
	if (locale === "de") return de_land_skin_4_title(inputs)
	if (locale === "es") return es_land_skin_4_title(inputs)
	if (locale === "fr") return fr_land_skin_4_title(inputs)
	if (locale === "it") return it_land_skin_4_title(inputs)
	if (locale === "ja") return ja_land_skin_4_title(inputs)
	if (locale === "ko") return ko_land_skin_4_title(inputs)
	if (locale === "pt_br") return pt_br_land_skin_4_title(inputs)
	if (locale === "ru") return ru_land_skin_4_title(inputs)
	if (locale === "th") return th_land_skin_4_title(inputs)
	if (locale === "tr") return tr_land_skin_4_title(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_4_title(inputs)
	return zh_tw_land_skin_4_title(inputs)
});